import React from "react";

interface LoginFailedProps {
  message?: string;
}

const LoginFailed: React.FC<LoginFailedProps> = ({
  message = "Login failed, come back again",
}) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-50 mb-4 border-2 border-red-200">
            <svg
              className="h-8 w-8 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Login Failed</h2>
          <p className="text-gray-600 text-base mb-6">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default LoginFailed;
